export const SIDE_BET_GAME_TYPE = 37

export const SIDE_BET_TYPES = {
  16: {
    key: 'playerPair',
    title: 'P Pair',
    calculator: 'pair',
    side: 'player',
    payout: '11:1',
    order: 2
  },
  32: {
    key: 'bankerPair',
    title: 'B Pair',
    calculator: 'pair',
    side: 'banker',
    payout: '11:1',
    order: 4
  },
  64: {
    key: 'playerDragon',
    title: 'Dragon Bonus Left',
    calculator: 'dragonBonus',
    side: 'player',
    order: 1
  },
  128: {
    key: 'bankerDragon',
    title: 'Dragon Bonus Right',
    calculator: 'dragonBonus',
    side: 'banker',
    order: 3
  }
}
